import { JournalId, SpecialConsultationId } from 'types';

export const SPECIAL_CONSULTATIONS = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/special-consultations`;
export const SPECIAL_CONSULTATION = (journalId: JournalId, consultationId: SpecialConsultationId) =>
    `/api/v1/journals/${journalId}/special-consultations/${consultationId}`;
